import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';

export enum ECallbackRoute {
  callback = 'callback',
  ponto = 'ponto',
}

CamRoutes.addRoute({
  key: ECallbackRoute.callback,
  url: 'callback',
  children: [
    {
      key: ECallbackRoute.ponto,
      url: 'ponto/:state/:code',
    },
  ],
});

export const callbackRoutes: Routes = [
  {
    path: CamRoutes.getUrl([ECallbackRoute.callback, ECallbackRoute.ponto]),
    loadComponent: () => import('./pages/ponto/callback-ponto.component').then(c => c.CallbackPontoPage),
  },
];
